import { CustomerSetupResponse } from '~/types';

/**
 * Type representing a plain JavaScript object that can be serialized to JSON.
 */
export type DocumentType =
    | null
    | boolean
    | number
    | string
    | DocumentType[]
    | {
          [prop: string]: DocumentType;
      };

export type RestApiOptionsBase = {
    withCredentials?: boolean;
};

export interface ApiInput<Options> {
    /**
     * Path of the REST API.
     */
    path: string;
    /**
     * Options to overwrite the REST API call behavior.
     */
    options?: Options;
}

export type GetInput = ApiInput<RestApiOptionsBase>;
export type PostInput = GetInput & {
    body?: DocumentType | FormData;
};

export type UseRestApiRequestResponseBase = {
    data?: DocumentType;
    error?: string;
    loading: boolean;
};

/**
 * Type representing an operation that can be canceled.
 *
 * @internal
 */
export interface Operation<Response> {
    response: Promise<Response>;
    cancel(abortMessage?: string): void;
}
interface ResponsePayload {
    blob(): Promise<Blob>;
    json(): Promise<DocumentType>;
    text(): Promise<string>;
}

type Headers = Record<string, string>;

/**
 * Basic response type of REST API.
 *
 * @internal
 */
export interface RestApiResponse {
    body: ResponsePayload;
    statusCode: number;
    headers: Headers;
}

export type UseRestApiGetRequestResponse = UseRestApiRequestResponseBase & {
    sendRequest: () => Promise<void>;
};

export interface UseRestApiPostRequestResponse<TResponse, TRequest = DocumentType | FormData> {
    data?: TResponse;
    loading: boolean;
    error?: ApiError;
    status?: number;
    sendRequest: (requestData?: TRequest) => Promise<TResponse | undefined>;
}

export class ApiError extends Error {
    response?: ApiErrorResponse;

    constructor(message: string, response?: ApiErrorResponse) {
        super(message);
        this.name = 'ApiError';
        this.response = response;
    }
}

export type TotalPlanValue = {
    amount: number;
    currency: string;
};

export type PolicyValuation = {
    totalPlanValue: TotalPlanValue;
};

export type ApiErrorResponseData = {
    redirectUrl?: string;
    message?: string;
};

export type ApiErrorResponse = {
    data?: ApiErrorResponseData;
    status: number;
};

export enum UserContextState {
    INIT = 'INIT',
    LOADING = 'LOADING',
    ERROR = 'ERROR',
    COMPLETE = 'COMPLETE',
}

export type UseUserContextResponse = UseRestApiRequestResponseBase & {
    data?: CustomerSetupResponse;
    reset: () => void;
};
